import * as graphql from '@treams/treams-network';
import { Paragraph, UnorderedList } from '@treams/treams-ui';

import { SharedFields } from '../ProductConfiguration';
import ProductLayout from '../ProductLayout';
import ProductTile from '../ProductTile';

function Description() {
	return (
		<>
			<Paragraph mb={2}>
				Nmbrs verbindt HR- en salarisprocessen in één systeem waarin het gebruiksgemak en
				medewerkers voorop staan. Van loonaangiftes tot contracten, van verlof tot verzuim; In Nmbrs
				verwerk jij al jouw personeelszaken zo veilig en efficiënt mogelijk in een digitaal dossier.
			</Paragraph>

			<Paragraph mb={2}>
				Met Nmbrs regel je gemakkelijk zelf de salarisverwerking voor jouw medewerkers. Door gebruik
				te maken van de HR workflows kun je heel eenvoudig en efficiënt HR-processen verwerken in
				Nmbrs en taken automatiseren. Daarnaast is het mogelijk om partijen te koppelen die voor jou
				relevant zijn om zo jouw ideale HR ecosysteem op te zetten.
			</Paragraph>

			<Paragraph mb={2}>
				Éfficiëntie, automatisering, gebruiksvriendelijkheid en continue innovatie staat aan de
				basis van onze software. Met een gedreven team gebruiken wij deze basis om voort te bouwen
				aan onze missie de beste online HR- en payroll software te ontwikkelen.
			</Paragraph>
			<Paragraph mb={2}>
				Core features:
				<UnorderedList>
					<li>Foutloze salarisverwerking</li>
					<li>Een compleet en digitaal personeelsdossier</li>
					<li>Gebruiksvriendelijke app</li>
					<li>Koppelingen met alle bekende bedrijfssoftware</li>
					<li>
						Tal van extra HR functionaliteiten zoals digitaal ondertekenen, HR workflows en
						verlofmanagement
					</li>
				</UnorderedList>
			</Paragraph>
		</>
	);
}

function translate(key: string): { title: string; description: string } | undefined {
	if (key === 'username') {
		return {
			title: 'Gebruikersnaam',
			description:
				'Je gaat zo een toegangssleutel genereren. Vul hier de gebruikersnaam in die je gaat gebruiken bij het genereren. Zorg dat dit account de juiste rechten heeft in Nmbrs.',
		};
	}

	if (key === 'token') {
		return {
			title: 'Token (toegangssleutel)',
			description: 'Vul hier de token van Nmbrs in. Je vindt deze in je Instellingen bij Nmbrs.',
		};
	}

	if (key === 'domain') {
		return {
			title: 'Domein',
			description:
				"Vul hier het domein van de Nmbrs website in. Dit is het domein waar je normaliter inlogt, bijvoorbeeld: apple.nmbrs.nl - Vul het domein in, inclusief 'nmbrs.nl'. Dit domein kan je eigen domein zijn of dat van bijvoorbeeld je boekhouder.",
		};
	}

	if (key === 'debtorIDs') {
		return {
			title: 'Debiteuren',
			description: 'Kies hier welke debiteuren uit Nmbrs je wil synchroniseren.',
		};
	}

	if (key === 'companyIDs') {
		return {
			title: 'Bedrijven',
			description: 'Kies hier welke bedrijven uit Nmbrs je wil synchroniseren.',
		};
	}

	if (key in SharedFields) {
		return SharedFields[key];
	}

	return {
		title: key,
		description: 'Nog niet geconfigureerd',
	};
}

export default function Nmbrs() {
	return (
		<ProductLayout
			id="nmbrs"
			type={graphql.ConnectorType.Nmbrs}
			description={<Description />}
			headerImageURL="https://assets.ontreams.com/marketplace/nmbrs-wide.png"
			translate={translate}
			pricingLink="https://www.nmbrs.com/nl/business/tarieven"
			documentationLink="https://treams.notion.site/Uitleg-Nmbrs-integreren-met-Treams-946c2213c0724a37abafd6c723bd376e"
		/>
	);
}

export function NmbrsTile(props: { selected: boolean }) {
	return (
		<ProductTile
			id="nmbrs"
			title="Nmbrs"
			description="Simpele oplossing voor al jouw HR en payroll processen"
			logoImageURL="https://assets.ontreams.com/marketplace/nmbrs-small.svg"
			selected={props.selected}
		/>
	);
}
